<template lang="pug">
  .campaign-dashboard__openTaskList(v-loading="loading")
    .dashboard-module__title(v-if="totalCount > 0 || hasSearched")
      div
        i.iconfont.icon-zhaoKOL(
          v-if="campaignType === 'unistar'"
        )
        i.iconfont(
          v-else
          :style="{color: '#3370d2', fontSize: '20px'}"
          :class="[campaignType === 'normal' ? 'icon-huodong' : 'icon-kuaijie']"
        )
        span {{ $t(title) }}
        span.task_count_container
          span.task_count {{ totalCount }}
      el-input(
        :placeholder="$t('请输入搜索内容')"
        v-model="keyword"
        @keyup.enter.native="handleSearch"
        style="width: 137px"
      )
        i(
          slot="suffix"
          class="el-input__icon el-icon-search"
          style="cursor: pointer"
          @click="handleSearch"
        )
    .openTaskList-content(v-if="totalCount !== 0")
      div(
        :id="campaignType === 'normal' ? 'openTaskList-content_expand' : 'openTaskList-lite-content_expand'"
        :class="[isCollapse ? 'openTaskList-content_collapse' : 'openTaskList-content_expand']"
        :style="{'max-height':campaignType === 'ec'?'460px': ''}"
      )
        #openTaskList-content__row
          el-row.openTaskList-content__row(:gutter="12")
            el-col(
              v-for="(item, index) in data"
              :key="index"
              :xs="6"
              :sm="6"
              :md="6"
              :lg="6"
              :xl="4"
              style="padding: 10px; "
            )
              e-c-campaign-card(
                v-if="campaignType === 'ec'"
                :item="item"
              )
              unistar-campaign-card(
                v-if="campaignType === 'star'"
                :item="item"
              )
              campaign-card(
                v-else
                :item="item"
                :campaignType="campaignType"
              )
        infinite-loading(
          :identifier="infiniteId"
          @infinite="getCampaignForDoing"
        )
    img(
      v-if="hasSearched && totalCount === 0"
      style="display:flex;margin:auto;height:155px"
      src="@/umcc/assets/no-data.jpg"
    )    
</template>

<script>
import CampaignCard from './CampaignCard'
import ECCampaignCard from './ECCampaignCard'
import UnistarCampaignCard from './UnistarCampaignCard'
import axios from 'axios'

const type = {
  'normal': 0,
  'lite': 1,
  'ec': 2,
  'star': 4
}

export default {
  components: {
    CampaignCard,
    ECCampaignCard,
    UnistarCampaignCard
  },
  data () {
    return {
      keyword: '',
      data: [],
      loading: true,
      isCollapse: false,
      page: 1,
      infiniteId: new Date(),
      totalCount: null,
      hasSearched: false
    }
  },   
  props: {
    campaignType: {
      type: String
    },
    title: {
      type: String
    }
  },
  methods: {
    async getCampaignForDoing ($state) {
      try {
        const result = await axios.get('/dashboard/getCampaignsForDoing', {
          params: {
            keyword: this.keyword,
            campaign_type: type[this.campaignType],
            page: this.page,
            size: 16 // 显示数量的两倍
          }
        })
        this.loading = false
        this.totalCount = result.total_count
        if (result[this.campaignType].length) {
          this.page += 1
          this.data.push(...result[this.campaignType])
          $state.loaded()
        } else {
          $state.complete()
        }
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    handleSearch () {
      
      this.hasSearched = true
      this.loading = true
      // init infinite loading
      this.getCampaignForDoing()
      this.keyword = this.keyword
      this.data = []
      this.page = 1
      this.infiniteId += 1
    }
  }
}
</script>

<style lang="stylus">
.campaign-dashboard__openTaskList
  margin-bottom 40px

.openTaskList-content
  .el-card
    &:hover
      box-shadow: 0 2px 14px 1px rgba(51, 112, 210, 0.94);
      .campaign_card_title
        color $main
    .el-card__body
      padding 22px !important
  .openTaskList-content__row
    margin 0 -6px !important

.openTaskList-content_expand
  max-height 350px
  overflow-y auto
  overflow-x hidden
  transition height .5s

.openTaskList-content_collapse
  height 180px
  overflow hidden
  transition height .5s

.openTaskList-lite-content_expand
  height 480px
  overflow-y auto
  overflow-x hidden
  transition height .5s

.openTaskList-lite-content_collapse
  height 240px
  overflow hidden
  transition height .5s

.campaign-dashboard__openTaskList__divider
  display flex
  align-items center
  span
    width 50%
    border-bottom 1px solid #cbddf9
    height 0.5
  .iconfont
    color #cbddf9
    cursor pointer
    font-size 20px
    margin 0 20px
</style>
